// Workflow statuses mirror the dealership "Current Batch Summary" report.
export const STATUS_ORDER = [
  "ready_to_submit",
  "pending_manual",
  "review",
  "required",
  "skip_maintenance",
];

export const STATUS_STYLES = {
  ready_to_submit: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  pending_manual: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  review: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  required: "bg-red-500/15 text-red-300 border-red-500/30",
  skip_maintenance: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  // legacy fallback
  pending_audit: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
};

export const STATUS_LABEL = {
  ready_to_submit: "Ready to Submit",
  pending_manual: "Ready — Pending Manual Verification",
  review: "Review Before Submission",
  required: "Required Before Submission",
  skip_maintenance: "Skip — Maintenance",
  pending_audit: "Ready — Pending Manual Verification",
};

// Short labels for tight table cells / stat cards
export const STATUS_SHORT = {
  ready_to_submit: "Ready to Submit",
  pending_manual: "Pending Manual",
  review: "Review",
  required: "Required",
  skip_maintenance: "Skip — Maintenance",
  pending_audit: "Pending Manual",
};

export function scoreColor(score) {
  if (score == null) return "text-muted-foreground";
  if (score >= 90) return "text-emerald-400";
  if (score >= 70) return "text-cyan-400";
  if (score >= 50) return "text-amber-400";
  return "text-red-400";
}

export function emptyRO() {
  return {
    ro_number: "",
    vin: "",
    vehicle_year: "",
    vehicle_make: "",
    vehicle_model: "",
    customer_name: "",
    ro_date: "",
    mileage_in: "",
    mileage_out: "",
    service_advisor: "",
    technician_id: "",
    signature_status: "unsigned",
    complaint: "",
    cause: "",
    correction: "",
    labor_op_code: "",
    labor_hours: "",
    claim_amount: "",
    diagnostic_reading: "",
    part_serial: "",
    compliance_status: "pending_manual",
    notes: "",
  };
}

export function toPayload(form) {
  const numeric = ["mileage_in", "mileage_out", "labor_hours", "claim_amount"];
  const out = { ...form };
  numeric.forEach((k) => {
    out[k] = out[k] === "" || out[k] === null ? null : Number(out[k]);
  });
  return out;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
